import { useAutocompleteSource } from '@eas/common-web';
import { DictInsuranceBrokerageAutocomplete } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useInsuranceBrokerages() {
  return useAutocompleteSource<DictInsuranceBrokerageAutocomplete>({
    url: `${EvidenceApiUrl.DICT_INSURANCE_BROKERAGE}/autocomplete`,
  });
}
